import { makeStyles } from '@material-ui/core';
import cloudhouseLogo from './cloudhouse-logo-horizontal.png';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    // Height drives width for the horizontal wordmark (~8.4:1 aspect). At 22px
    // it renders ~185px wide, fitting within the open sidebar drawer (~224px
    // less the 24px left margin) without overflowing.
    height: 22,
    display: 'block',
  },
});

// Official Cloudhouse wordmark (green on transparent), bundled via import so
// the asset is hashed and served by the bundler. Shown in the expanded sidebar;
// the navy sidebar background suits the green logo.
export const LogoFull = () => {
  const classes = useStyles();

  return <img className={classes.img} src={cloudhouseLogo} alt="Cloudhouse" />;
};
